/**
 * Read More / Lire la suite - Mobile only
 * Pour la description de collection et le bloc texte+images
 * Note : le contenu HTML manipule provient du rendu server-side Shopify (richtext admin)
 */

(function() {
  'use strict';

  var CONFIG = {
    maxLength: 150,
    mobileBreakpoint: 768,
    readMoreText: 'Lire la suite',
    readLessText: 'Lire moins'
  };

  function truncateText(element) {
    if (element.dataset.readMoreProcessed) return;

    var fullText = element.textContent.trim();

    if (fullText.length <= CONFIG.maxLength) return;

    element.dataset.readMoreProcessed = 'true';

    // Sauvegarder les noeuds DOM originaux (contenu Shopify server-side)
    var originalNodes = [];
    while (element.firstChild) {
      originalNodes.push(element.removeChild(element.firstChild));
    }

    var truncatedText = fullText.substring(0, CONFIG.maxLength) + '...';

    var wrapper = document.createElement('div');
    wrapper.className = 'read-more-wrapper';

    var textContainer = document.createElement('div');
    textContainer.className = 'read-more-text';
    textContainer.textContent = truncatedText;

    var button = document.createElement('button');
    button.className = 'read-more-btn';
    button.textContent = CONFIG.readMoreText;
    button.setAttribute('type', 'button');
    button.setAttribute('aria-expanded', 'false');

    button.addEventListener('click', function() {
      var isExpanded = button.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        // Reduire : vider et remettre le texte tronque
        while (textContainer.firstChild) {
          textContainer.removeChild(textContainer.firstChild);
        }
        textContainer.textContent = truncatedText;
        button.textContent = CONFIG.readMoreText;
        button.setAttribute('aria-expanded', 'false');
      } else {
        // Agrandir : restaurer les noeuds DOM originaux
        textContainer.textContent = '';
        originalNodes.forEach(function(node) {
          textContainer.appendChild(node.cloneNode(true));
        });
        button.textContent = CONFIG.readLessText;
        button.setAttribute('aria-expanded', 'true');
      }
    });

    wrapper.appendChild(textContainer);
    wrapper.appendChild(button);
    element.appendChild(wrapper);

    // Stocker les noeuds originaux sur l'element pour restoreText
    element._originalNodes = originalNodes;
  }

  function restoreText(element) {
    if (!element.dataset.readMoreProcessed) return;

    // Restaurer les noeuds DOM originaux
    var originalNodes = element._originalNodes;
    if (originalNodes) {
      while (element.firstChild) {
        element.removeChild(element.firstChild);
      }
      originalNodes.forEach(function(node) {
        element.appendChild(node);
      });
      delete element._originalNodes;
    }

    delete element.dataset.readMoreProcessed;
  }

  function init() {
    var isMobile = window.innerWidth <= CONFIG.mobileBreakpoint;

    var targets = [
      document.querySelector('.collection-description .enlarge-text'),
      document.querySelector('.text-with-images-content')
    ];

    targets.forEach(function(element) {
      if (element) {
        if (isMobile) {
          truncateText(element);
        } else {
          restoreText(element);
        }
      }
    });
  }

  function debounce(func, wait) {
    var timeout;
    return function() {
      var later = function() {
        clearTimeout(timeout);
        func();
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', debounce(init, 250));
  document.addEventListener('shopify:section:load', init);
})();
